import {IntegrationType, IntegrationTypeNum} from 'enums/integrations';

export const integrationTypeMap = {
  [IntegrationTypeNum.GOOGLE_CLASSROOM]: IntegrationType.GOOGLE_CLASSROOM,
  [IntegrationTypeNum.MICROSOFT_TEAMS]: IntegrationType.MICROSOFT_TEAMS,
  [IntegrationTypeNum.GOOGLE_SITES_SOURCE]: IntegrationType.GOOGLE_SITES_SOURCE,
  [IntegrationTypeNum.GOOGLE_SITES_DESTINATION]: IntegrationType.GOOGLE_SITES_DESTINATION,
};
